import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import BrandLogo from './BrandLogo';
import { LogOut, ShieldCheck, Sparkles } from 'lucide-react';

export default function AppHeader() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-zinc-200" data-testid="app-header">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
          <BrandLogo filled className="w-11 h-11" />
          <div className="hidden sm:block">
            <div className="font-display font-bold text-zinc-950 leading-none">STArtIn AI</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 mt-0.5">SMEs Thinking Artificial Intelligence</div>
          </div>
        </Link>

        <nav className="flex items-center gap-2">
          {user && <Link to="/welcome" className="hidden md:block text-sm text-zinc-600 hover:text-zinc-950 px-3 py-2 transition-colors" data-testid="nav-welcome">Introduction</Link>}
          <Link to="/assessment" className="hidden md:block text-sm text-zinc-600 hover:text-zinc-950 px-3 py-2 transition-colors" data-testid="nav-assessment">Assessment</Link>
          <Link to="/history" className="hidden md:block text-sm text-zinc-600 hover:text-zinc-950 px-3 py-2 transition-colors" data-testid="nav-history">History</Link>
          {user?.is_admin && (
            <Link to="/admin" className="hidden md:flex items-center gap-1.5 text-sm text-zinc-600 hover:text-zinc-950 px-3 py-2 transition-colors" data-testid="nav-admin">
              <ShieldCheck className="w-3.5 h-3.5" /> Admin
            </Link>
          )}

          {user && (
            <div className="flex items-center gap-3 ml-3 pl-3 border-l border-zinc-200">
              <div className="text-right hidden md:block">
                <div className="text-xs font-medium text-zinc-950 truncate max-w-[180px]" data-testid="user-company">{user.company_name}</div>
                <div className="text-[11px] text-zinc-500 truncate max-w-[180px]">{user.email}</div>
              </div>
              <button
                onClick={() => { logout(); nav('/auth'); }}
                className="text-xs flex items-center gap-1.5 text-zinc-600 hover:text-[#FF3B30] px-3 py-2 transition-colors"
                data-testid="logout-button"
              >
                <LogOut className="w-3.5 h-3.5" /> Logout
              </button>
            </div>
          )}
          {!user && (
            <Link to="/auth" className="bg-[#002FA7] text-white text-sm px-4 py-2 hover:bg-[#00227A] transition-colors flex items-center gap-1.5" data-testid="header-signin-btn">
              <Sparkles className="w-3.5 h-3.5" /> Sign in
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
